import { FC } from 'react';

import { LoadingSkeleton, Placeholder } from '~/vinovest-design-system/components';

import { SummaryItem } from '../SummaryTable/SummaryItem';

export const WireTransferEntry: FC<
    React.PropsWithChildren<{ label: string; renderCondition?: boolean; classnames?: string }>
> = ({ children, renderCondition, classnames, label }) => {
    return (
        <SummaryItem label={label} classnames={classnames}>
            <Placeholder
                renderCondition={renderCondition ?? true}
                placeholder={<LoadingSkeleton height={'20px'} width={'50%'} />}
            >
                {children}
            </Placeholder>
        </SummaryItem>
    );
};
